import React from 'react';
import { Switch, Route, NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import UserSettings from './UserSettings/UserSettings';
import OrganizationSettings from './OrganizationSettings/OrganizationSettings';
import UsersList from './Users/UsersList';
// import Users from './Users/Users';

import PageHeader from '../Layout/PageHeader/PageHeader';

function Settings() {
    const { t } = useTranslation();
    const user = useSelector(state => state.user);

    const PageHeaderNav = (
        <ul className="nav">
            <li className="nav-item active">
                <NavLink exact to={`/settings`} activeClassName='active'>{t('settings.my_info')}</NavLink>
            </li>
            <li className="nav-item">
                <NavLink to={`/settings/organization`} activeClassName='active'>{t('settings.organization_info')}</NavLink>
            </li>
            <li className="nav-item">
                <NavLink to={`/settings/users`} activeClassName='active'>{t('settings.user_management')}</NavLink>
            </li>
        </ul>
    );

    return (
        (user && user.data) ?
            <React.Fragment>
                <PageHeader
                    title={t('settings.settings')}
                    subtitle={t('settings.subtitle')}
                    nav={PageHeaderNav}
                />
                <div className="container">
                    <Switch>
                        <Route path="/settings/organization">
                            <OrganizationSettings organizationID={user.data.organizationID} />
                        </Route>
                        <Route path="/settings/users">
                            <UsersList organizationID={user.data.organizationID} />
                            {/* <Users organizationID={user.data.organizationID} /> */}
                        </Route>
                        <Route exact path="/settings">
                            <UserSettings user={user.data} loading={user.loading} errors={user.errors} />
                        </Route>
                    </Switch>
                </div>
            </React.Fragment>
        : null
    )
}

export default Settings;